export type CreateComponentProjectRequest = {
  cpntPjtTypeCd: string;
  dipByRgn: string;
  cpntId: string;
  ptnrId?: string;
  inOutTypeCd: string;
  prtclTypeCd: string;
  deletePjtFlg: string;
  stgOnlyFlg: string;
  constructWithOtherStgFlg: string;
  changeAttributeFlg?: string;
  changeInfraFlg: string;
};
